import { Avatar } from "@chakra-ui/react";

// Chakra's <Avatar> auto-generates a background colour by hashing the name,
// which produces clashing neon tones (pink/green/yellow/navy). BrandAvatar
// pins the fallback background to a small, muted, bordeaux-friendly palette so
// initials read as one coherent family. When a real photo (src) is present the
// image covers the background anyway.
const PALETTE = [
  { bg: "#7A2E2E", color: "white" }, // bordeaux (brand)
  { bg: "#A65B4B", color: "white" }, // clay
  { bg: "#6B7257", color: "white" }, // muted olive
  { bg: "#44566B", color: "white" }, // slate
  { bg: "#B08868", color: "white" }, // camel
  { bg: "#5F2A3A", color: "white" }, // deep plum
];

const hash = (s = "") => {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
};

// Backends sometimes return a placeholder/default avatar string instead of a
// real photo. Chakra would then render that (often blank/transparent) image
// *over* the initials, leaving an empty coloured circle with no letters. Drop
// such values so the initials show instead. Genuinely broken URLs already fall
// back to initials via Chakra's onError, so we only need to filter the
// known-junk and default-placeholder values here.
const PLACEHOLDER_SRC = new Set([
  "null",
  "undefined",
  "false",
  "0",
  "/avatar.jpg",
  "avatar.jpg",
  "/avatar.png",
  "avatar.png",
  "/default-avatar.png",
  "/default_avatar.png",
  "/placeholder.png",
  "/placeholder.jpg",
]);

const usableSrc = (src) => {
  if (!src) return undefined;
  const s = String(src).trim();
  if (!s || PLACEHOLDER_SRC.has(s.toLowerCase())) return undefined;
  return s;
};

export function BrandAvatar({ name = "", src, ...props }) {
  const { bg, color } = PALETTE[hash(name) % PALETTE.length];
  return (
    <Avatar name={name} src={usableSrc(src)} bg={bg} color={color} {...props} />
  );
}

export default BrandAvatar;
